export const LIMIT_TIER_1K = 1000;
export const LIMIT_TIER_2K = 2000;
export const LIMIT_TIER_10K = 10000;
export const LIMIT_TIER_100K = 100000;
